import React, { FunctionComponent } from 'react';
import { useNavigate } from 'react-router-dom';

import { CommonError } from 'src/components/common-error';
import { i18n } from 'src/i18n';
import { owlImageProps } from 'src/resources/images';
import { DataLayerEcomErrors } from 'src/types/data-layer-event-object';
import { useAppSelector } from 'src/state/thunk-api';
import { selectAccounts } from 'src/state/account/selectors';
import { NavigationService } from 'src/services/navigation-service';

export const PageWrongRole: FunctionComponent = () => {
  const accounts = useAppSelector(selectAccounts);
  const navigate = useNavigate();

  return (
    <CommonError
      title={i18n.page.error.wrongRole.title}
      subtitles={[i18n.page.error.wrongRole.accountOwner, i18n.page.error.wrongRole.selectCorrectAccount]}
      image={owlImageProps}
      hideCustomerServiceText={true}
      dataLayerErrorMessage={DataLayerEcomErrors.WRONG_ROLE}
      buttonOptions={
        accounts.length > 1
          ? {
              onClick: () => navigate(NavigationService.CHOOSE_ACCOUNT),
              children: i18n.page.error.wrongRole.buttonText,
            }
          : undefined
      }
    />
  );
};
